import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
import TextType from './TextType';
import cadBg from '../pics/cad-pics/cadjpg.jpg';
import archBg from '../pics/arch-pics/archjpg.jpg';
import { useSection } from '../context/SectionContext';

const LandingPage = () => {
  const [exitingSide, setExitingSide] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const navigate = useNavigate();
  const { setSection } = useSection();

  const handleNavigation = (path, side) => {
    setExitingSide(side);
    setIsTransitioning(true);
    setSection(side === 'cad' ? 'cad' : 'architecture');
    setTimeout(() => {
      navigate(path);
    }, 1500);
  };

  return (
    <div className='landing-container'>
      {/* Single DotGrid Background for entire page */}
      {/* <div className='global-background'>
        <DotGrid
          dotSize={6}
          gap={30}
          baseColor='#ffffff'
          activeColor='#ffffff'
          proximity={150}
          shockRadius={200}
          shockStrength={4}
          resistance={800}
          returnDuration={1.5}
        />
      </div> */}

      {/* Waves Background for entire page */}
      {/* <div className='global-background'>
        <Waves
          lineColor='rgba(255, 255, 255, 0.15)'
          backgroundColor='transparent'
          waveSpeedX={0.0125}
          waveSpeedY={0.005}
          waveAmpX={32}
          waveAmpY={16}
          xGap={10}
          yGap={32}
          friction={0.925}
          tension={0.005}
          maxCursorMove={120}
        />
      </div> */}

      {/* Centered Light Rays Effect for entire page */}
      {/* <div className='global-light-rays'>
        <LightRays
          raysOrigin='top-center'
          raysColor='#ffffff'
          raysSpeed={2.5}
          lightSpread={0.3}
          rayLength={3}
          followMouse={true}
          mouseInfluence={0.8}
          noiseAmount={0.02}
          distortion={0.01}
          fadeDistance={2}
          saturation={2}
        />
      </div> */}

      {isTransitioning && (
        <div className='loading-overlay'>
          {/* 3D Model Container */}

          {/* Main content */}
          <div className='loading-content'>
            <TextType
              text={[exitingSide === 'cad' ? 'CAD SERVICES' : 'ARCHITECTURE']}
              typingSpeed={60}
              pauseDuration={500}
              deletingSpeed={30}
              showCursor={true}
              cursorCharacter='_'
              loop={false}
              className='loading-text-type'
            />
          </div>

          {/* Scanline effect */}
          <div className='scanline'></div>
        </div>
      )}

      <div
        className={`landing-side cad-side ${exitingSide === 'cad' ? 'active' : ''} ${exitingSide === 'architecture' ? 'exit-left' : ''}`}
        onClick={() => handleNavigation('/cad-services', 'cad')}
        style={{ backgroundImage: `url(${cadBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className='corner-lines'>
          <div className='corner-line top-left'></div>
          <div className='corner-line bottom-right'></div>
        </div>
        <div className='side-title'>
          <h1>CAD Services</h1>
        </div>
      </div>

      <div
        className={`landing-side architecture-side ${exitingSide === 'architecture' ? 'active' : ''} ${exitingSide === 'cad' ? 'exit-right' : ''}`}
        onClick={() => handleNavigation('/architecture', 'architecture')}
        style={{ backgroundImage: `url(${archBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className='corner-lines'>
          <div className='corner-line top-left'></div>
          <div className='corner-line bottom-right'></div>
        </div>
        <div className='side-title'>
          <h1>Architecture</h1>
        </div>
      </div>

      <div className='animated-lines'>
        <div className='diagonal-line line-1'></div>
        <div className='diagonal-line line-2'></div>
        <div className='diagonal-line line-3'></div>
      </div>
    </div>
  );
};

export default LandingPage;
